module.exports = __webpack_public_path__ + "static/media/Brescia.f46c6a28.png";